import {
  RizeColors,
  AlbasterColors,
  JuniperColors,
  StrandColors,
  FormwerksColors,
  ShapeColors,
  QuadraColors,
  PanatchColors,
  GateHouseColors,
} from '../src/styles/TenantStyles';
import { HOTJAR_VERSION, PATHS } from './common/constants';
import packageJson from '../package.json';
import Hotjar from '@hotjar/browser';
import { tenants } from './common/TenantsInformation';
import { store } from './store/index';
import { setBuildVersion } from './store/actions/formOptions';
import { getNewAuthorizationToken, setReport } from './store/actions/auth';
import { jwtDecode } from 'jwt-decode'; // This is new.
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getBrandingOverrides } from './branding/getBrandingOverrides';
import {
  applyBrandingToLegacyStyles,
  prepareLegacyColours,
  prepareLegacyImages,
  prepareLegacyVariables,
} from './branding/legacy';

var Images;
var Colors;
let variables = {
  suiteName: 'Suites',
  Suite: 'Suite',
  suite: 'suite',
  suites: 'suites',
  serviceRequest: 'Service Request',

  roomName: 'Room',

  homeOwners: 'Home Owners',
  homeOwnerss: 'Homeowners',
  homeOwner: 'Homeowner',

  propertyDeveloper: 'Property Developer',
  propertyDevelopers: 'property developers',

  developers: 'Developers',
  developerss: 'developers',
  developer: 'Developer',
  roomsAndItems: 'Rooms and Items',
  termsOfUse: 'Terms of Use',
  conveyance: 'Conveyance',
  userActivationMessage:
    'Welcome to Juniper, you have successfully activated your account! Please create your password below.',
};
let baseUrl;
let resolutionHeader;
let AnalyticsKey;

export const matchUrl = (tenantUrls, givenUrl) => {
  var matchFound = tenantUrls.includes(givenUrl);
  return matchFound;
};

export const getTenantGUID = (url) => {
  const tenantObj = tenants.filter((t) => matchUrl(t.urls, url))[0];

  // If no tenant found, default to localhost
  if (!tenantObj) {
    console.warn(`No tenant found for URL: ${url}. Defaulting to localhost.`);
    const localhostTenant = tenants.find(
      (t) =>
        t.urls.includes('http://app.localhost:3000') ||
        t.urls.some((u) => u.includes('localhost:3000'))
    );

    if (localhostTenant) {
      console.log(`Using localhost tenant: ${localhostTenant.tenant}`);
      return localhostTenant.resolutionHeaderValue;
    }

    // If no localhost tenant found, return a default or throw an error
    console.error('No localhost tenant found');
    return null; // or a default GUID/value
  }

  console.log(`${tenantObj.tenant} has been loaded.`);
  return tenantObj.resolutionHeaderValue;
};

export const verifyTenent = async (url) => {
  // getDeploymentVersion(url);
  let tenantObj = tenants.filter((tn) => matchUrl(tn.urls, url))[0];
  let theme = tenantObj && tenantObj.tenant ? tenantObj.tenant : '';
  await localStorage.setItem('theme', theme);

  const overrides = await getBrandingOverrides(
    tenantObj?.resolutionHeaderValue
  );
  if (overrides.length) {
    const branding = overrides[0];
    applyBrandingToLegacyStyles(branding);
    Images = prepareLegacyImages(branding, tenantObj.extraInfo.QRCode);
    Colors = prepareLegacyColours(branding);
    variables = prepareLegacyVariables(branding);
  } else {
    setTenantTheme(theme);
    setTenantImages(theme);
    setTenantColors(theme);
    setTenantVariables(theme);
  }

  setTenantAPIURL(theme);
  setTenantResolutionHeader(theme);
  setTenantAnalytics(theme);
  setHotJarKey(theme);
};

export const setTenantTheme = (theme) => {
  if (theme === 'Rize') {
    document.documentElement.style.setProperty(
      '--color-ink-lightest',
      RizeColors['color-ink-lightest']
    );
    document.documentElement.style.setProperty(
      '--color-complete-button',
      RizeColors['color-complete-button']
    );
    document.documentElement.style.setProperty(
      '--color-teal-dark',
      RizeColors['color-teal-dark']
    );
    document.documentElement.style.setProperty(
      '--button-background-color',
      RizeColors['button-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper',
      RizeColors['color-juniper']
    );
    document.documentElement.style.setProperty(
      '--toast-message-text',
      RizeColors['toast-message-text']
    );
    document.documentElement.style.setProperty(
      '--color-search-border',
      RizeColors['color-search-border']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lighter',
      RizeColors['color-ink-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-disabled-button',
      RizeColors['color-disabled-button']
    );
    document.documentElement.style.setProperty(
      '--color-sky',
      RizeColors['color-sky']
    );
    document.documentElement.style.setProperty(
      '--color-teal',
      RizeColors['color-teal']
    );
    document.documentElement.style.setProperty(
      '--color-checkIcon',
      RizeColors['color-checkIcon']
    );
    document.documentElement.style.setProperty(
      '--walkthroughcompletecheckbox',
      RizeColors['walkthroughcompletecheckbox']
    );
    document.documentElement.style.setProperty(
      '--color-ink-light',
      RizeColors['color-ink-light']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-dark',
      RizeColors['color-juniper-dark']
    );
    document.documentElement.style.setProperty(
      '--tab-background-color',
      RizeColors['tab-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-darker',
      RizeColors['color-juniper-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-darker',
      RizeColors['color-red-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-lighter',
      RizeColors['color-red-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky-dark',
      RizeColors['color-sky-dark']
    );
    document.documentElement.style.setProperty(
      '--color-teal-darker',
      RizeColors['color-teal-darker']
    );
    document.documentElement.style.setProperty(
      '--color-teal-lighter',
      RizeColors['color-teal-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-lighter',
      RizeColors['color-yellow-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-darker',
      RizeColors['color-yellow-darker']
    );
    document.documentElement.style.setProperty('--links', RizeColors['links']);
    document.documentElement.style.setProperty(
      '--color-dark',
      RizeColors['color-dark']
    );

    document.documentElement.style.setProperty(
      '--breadcrumb',
      RizeColors['breadcrumb']
    );
    document.documentElement.style.setProperty(
      '--left-nav-text-color',
      RizeColors['left-nav-text-color']
    );
    document.documentElement.style.setProperty(
      '--left-nav-active-text-color',
      RizeColors['left-nav-active-text-color']
    );
    document.documentElement.style.setProperty(
      '--time-line',
      RizeColors['time-line']
    );
    document.documentElement.style.setProperty(
      '--toast-background-shadow',
      RizeColors['toast-background-shadow']
    );
    document.documentElement.style.setProperty(
      '--icomoon-color',
      RizeColors['icomoon-color']
    );
    document.documentElement.style.setProperty(
      '--sidebar-tenant-color',
      RizeColors['sidebar-tenant-color']
    );
    document.documentElement.style.setProperty(
      '--closed-overview-color',
      RizeColors['closed-overview-color']
    );
    document.documentElement.style.setProperty(
      '--backGroundColors',
      RizeColors['backGroundColors']
    );
    document.documentElement.style.setProperty(
      '--recentActivityPanColor',
      RizeColors['recentActivityPanColor']
    );
    document.documentElement.style.setProperty(
      '--HOtitle',
      RizeColors['HOtitle']
    );
    document.documentElement.style.setProperty(
      '--textAreaOnFocusBroderHighLight',
      RizeColors['textAreaOnFocusBroderHighLight']
    );
    document.documentElement.style.setProperty(
      '--tableListHoverColor',
      RizeColors['tableListHoverColor']
    );

    document.documentElement.style.setProperty(
      '--toastSuccessColor',
      RizeColors['toastSuccessColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBackGroundColor',
      RizeColors['toastSuccessBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBorderColor',
      RizeColors['toastSuccessBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessProgressBarColor',
      RizeColors['toastSuccessProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessCloseButtonColor',
      RizeColors['toastSuccessCloseButtonColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorColor',
      RizeColors['toastErrorColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBackGroundColor',
      RizeColors['toastErrorBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBorderColor',
      RizeColors['toastErrorBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorProgressBarColor',
      RizeColors['toastErrorProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorCloseButtonColor',
      RizeColors['toastErrorCloseButtonColor']
    );

    document.documentElement.style.setProperty(
      '--primary-heading-font',
      RizeColors['primary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--general-content-font',
      RizeColors['general-content-font']
    );
    document.documentElement.style.setProperty(
      '--secondary-heading-font',
      RizeColors['secondary-heading-font']
    );

    document.documentElement.style.setProperty(
      '--color-issue-type-header',
      RizeColors['color-issue-type-header']
    );
    document.documentElement.style.setProperty(
      '--color-anchor-link',
      RizeColors['color-anchor-link']
    );

    document.documentElement.style.setProperty(
      '--color-left-nav-background',
      RizeColors['color-left-nav-background']
    );
    document.documentElement.style.setProperty(
      '--complete-button',
      RizeColors['complete-button']
    );
    document.documentElement.style.setProperty(
      '--color-expires-text',
      RizeColors['color-expires-text']
    );
  } else if (theme === 'Albaster') {
    document.documentElement.style.setProperty(
      '--color-expires-text',
      AlbasterColors['color-expires-text']
    );
    document.documentElement.style.setProperty(
      '--color-complete-button',
      AlbasterColors['color-complete-button']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lightest',
      AlbasterColors['color-ink-lightest']
    );
    document.documentElement.style.setProperty(
      '--color-disabled-button',
      AlbasterColors['color-disabled-button']
    );
    document.documentElement.style.setProperty(
      '--color-teal-dark',
      AlbasterColors['color-teal-dark']
    );
    document.documentElement.style.setProperty(
      '--button-background-color',
      AlbasterColors['button-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper',
      AlbasterColors['color-juniper']
    );
    document.documentElement.style.setProperty(
      '--toast-message-text',
      AlbasterColors['toast-message-text']
    );
    document.documentElement.style.setProperty(
      '--color-search-border',
      AlbasterColors['color-search-border']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lighter',
      AlbasterColors['color-ink-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky',
      AlbasterColors['color-sky']
    );
    document.documentElement.style.setProperty(
      '--color-teal',
      AlbasterColors['color-teal']
    );
    document.documentElement.style.setProperty(
      '--color-checkIcon',
      AlbasterColors['color-checkIcon']
    );
    document.documentElement.style.setProperty(
      '--walkthroughcompletecheckbox',
      AlbasterColors['walkthroughcompletecheckbox']
    );
    document.documentElement.style.setProperty(
      '--color-ink-light',
      AlbasterColors['color-ink-light']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-dark',
      AlbasterColors['color-juniper-dark']
    );
    document.documentElement.style.setProperty(
      '--tab-background-color',
      AlbasterColors['tab-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-darker',
      AlbasterColors['color-juniper-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-darker',
      AlbasterColors['color-red-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-lighter',
      AlbasterColors['color-red-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky-dark',
      AlbasterColors['color-sky-dark']
    );
    document.documentElement.style.setProperty(
      '--color-teal-darker',
      AlbasterColors['color-teal-darker']
    );
    document.documentElement.style.setProperty(
      '--color-teal-lighter',
      AlbasterColors['color-teal-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-lighter',
      AlbasterColors['color-yellow-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-darker',
      AlbasterColors['color-yellow-darker']
    );
    document.documentElement.style.setProperty(
      '--links',
      AlbasterColors['links']
    );
    document.documentElement.style.setProperty(
      '--color-dark',
      AlbasterColors['color-dark']
    );

    document.documentElement.style.setProperty(
      '--breadcrumb',
      AlbasterColors['breadcrumb']
    );
    document.documentElement.style.setProperty(
      '--left-nav-text-color',
      AlbasterColors['left-nav-text-color']
    );
    document.documentElement.style.setProperty(
      '--left-nav-active-text-color',
      AlbasterColors['left-nav-active-text-color']
    );
    document.documentElement.style.setProperty(
      '--time-line',
      AlbasterColors['time-line']
    );
    document.documentElement.style.setProperty(
      '--toast-background-shadow',
      AlbasterColors['toast-background-shadow']
    );
    document.documentElement.style.setProperty(
      '--icomoon-color',
      AlbasterColors['icomoon-color']
    );
    document.documentElement.style.setProperty(
      '--sidebar-tenant-color',
      AlbasterColors['sidebar-tenant-color']
    );
    document.documentElement.style.setProperty(
      '--closed-overview-color',
      AlbasterColors['closed-overview-color']
    );
    document.documentElement.style.setProperty(
      '--backGroundColors',
      AlbasterColors['backGroundColors']
    );
    document.documentElement.style.setProperty(
      '--recentActivityPanColor',
      AlbasterColors['recentActivityPanColor']
    );
    document.documentElement.style.setProperty(
      '--HOtitle',
      AlbasterColors['HOtitle']
    );
    document.documentElement.style.setProperty(
      '--textAreaOnFocusBroderHighLight',
      AlbasterColors['textAreaOnFocusBroderHighLight']
    );
    document.documentElement.style.setProperty(
      '--tableListHoverColor',
      AlbasterColors['tableListHoverColor']
    );

    document.documentElement.style.setProperty(
      '--toastSuccessColor',
      AlbasterColors['toastSuccessColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBackGroundColor',
      AlbasterColors['toastSuccessBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBorderColor',
      AlbasterColors['toastSuccessBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessProgressBarColor',
      AlbasterColors['toastSuccessProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessCloseButtonColor',
      AlbasterColors['toastSuccessCloseButtonColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorColor',
      AlbasterColors['toastErrorColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBackGroundColor',
      AlbasterColors['toastErrorBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBorderColor',
      AlbasterColors['toastErrorBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorProgressBarColor',
      AlbasterColors['toastErrorProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorCloseButtonColor',
      AlbasterColors['toastErrorCloseButtonColor']
    );

    document.documentElement.style.setProperty(
      '--primary-heading-font',
      AlbasterColors['primary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--general-content-font',
      AlbasterColors['general-content-font']
    );
    document.documentElement.style.setProperty(
      '--secondary-heading-font',
      AlbasterColors['secondary-heading-font']
    );

    document.documentElement.style.setProperty(
      '--color-issue-type-header',
      AlbasterColors['color-issue-type-header']
    );

    document.documentElement.style.setProperty(
      '--color-anchor-link',
      AlbasterColors['color-anchor-link']
    );
    document.documentElement.style.setProperty(
      '--color-left-nav-background',
      AlbasterColors['color-left-nav-background']
    );
    document.documentElement.style.setProperty(
      '--complete-button',
      AlbasterColors['complete-button']
    );
  } else if (theme === 'Strand') {
    document.documentElement.style.setProperty(
      '--color-expires-text',
      StrandColors['color-expires-text']
    );
    document.documentElement.style.setProperty(
      '--color-complete-button',
      StrandColors['color-complete-button']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lightest',
      StrandColors['color-ink-lightest']
    );
    document.documentElement.style.setProperty(
      '--color-disabled-button',
      StrandColors['color-disabled-button']
    );
    document.documentElement.style.setProperty(
      '--color-teal-dark',
      StrandColors['color-teal-dark']
    );
    document.documentElement.style.setProperty(
      '--button-background-color',
      StrandColors['button-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper',
      StrandColors['color-juniper']
    );
    document.documentElement.style.setProperty(
      '--toast-message-text',
      StrandColors['toast-message-text']
    );
    document.documentElement.style.setProperty(
      '--color-search-border',
      StrandColors['color-search-border']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lighter',
      StrandColors['color-ink-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky',
      StrandColors['color-sky']
    );
    document.documentElement.style.setProperty(
      '--color-teal',
      StrandColors['color-teal']
    );
    document.documentElement.style.setProperty(
      '--color-checkIcon',
      StrandColors['color-checkIcon']
    );
    document.documentElement.style.setProperty(
      '--walkthroughcompletecheckbox',
      StrandColors['walkthroughcompletecheckbox']
    );
    document.documentElement.style.setProperty(
      '--color-ink-light',
      StrandColors['color-ink-light']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-dark',
      StrandColors['color-juniper-dark']
    );
    document.documentElement.style.setProperty(
      '--tab-background-color',
      StrandColors['tab-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-darker',
      StrandColors['color-juniper-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-darker',
      StrandColors['color-red-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-lighter',
      StrandColors['color-red-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky-dark',
      StrandColors['color-sky-dark']
    );
    document.documentElement.style.setProperty(
      '--color-teal-darker',
      StrandColors['color-teal-darker']
    );
    document.documentElement.style.setProperty(
      '--color-teal-lighter',
      StrandColors['color-teal-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-lighter',
      StrandColors['color-yellow-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-darker',
      StrandColors['color-yellow-darker']
    );
    document.documentElement.style.setProperty(
      '--links',
      StrandColors['links']
    );
    document.documentElement.style.setProperty(
      '--color-dark',
      StrandColors['color-dark']
    );

    document.documentElement.style.setProperty(
      '--breadcrumb',
      StrandColors['breadcrumb']
    );
    document.documentElement.style.setProperty(
      '--left-nav-text-color',
      StrandColors['left-nav-text-color']
    );
    document.documentElement.style.setProperty(
      '--left-nav-active-text-color',
      StrandColors['left-nav-active-text-color']
    );
    document.documentElement.style.setProperty(
      '--time-line',
      StrandColors['time-line']
    );
    document.documentElement.style.setProperty(
      '--toast-background-shadow',
      StrandColors['toast-background-shadow']
    );
    document.documentElement.style.setProperty(
      '--icomoon-color',
      StrandColors['icomoon-color']
    );
    document.documentElement.style.setProperty(
      '--sidebar-tenant-color',
      StrandColors['sidebar-tenant-color']
    );
    document.documentElement.style.setProperty(
      '--closed-overview-color',
      StrandColors['closed-overview-color']
    );
    document.documentElement.style.setProperty(
      '--backGroundColors',
      StrandColors['backGroundColors']
    );
    document.documentElement.style.setProperty(
      '--recentActivityPanColor',
      StrandColors['recentActivityPanColor']
    );
    document.documentElement.style.setProperty(
      '--HOtitle',
      StrandColors['HOtitle']
    );
    document.documentElement.style.setProperty(
      '--textAreaOnFocusBroderHighLight',
      StrandColors['textAreaOnFocusBroderHighLight']
    );
    document.documentElement.style.setProperty(
      '--tableListHoverColor',
      StrandColors['tableListHoverColor']
    );

    document.documentElement.style.setProperty(
      '--toastSuccessColor',
      StrandColors['toastSuccessColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBackGroundColor',
      StrandColors['toastSuccessBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBorderColor',
      StrandColors['toastSuccessBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessProgressBarColor',
      StrandColors['toastSuccessProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessCloseButtonColor',
      StrandColors['toastSuccessCloseButtonColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorColor',
      StrandColors['toastErrorColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBackGroundColor',
      StrandColors['toastErrorBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBorderColor',
      StrandColors['toastErrorBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorProgressBarColor',
      StrandColors['toastErrorProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorCloseButtonColor',
      StrandColors['toastErrorCloseButtonColor']
    );

    document.documentElement.style.setProperty(
      '--primary-heading-font',
      StrandColors['primary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--general-content-font',
      StrandColors['general-content-font']
    );
    document.documentElement.style.setProperty(
      '--secondary-heading-font',
      StrandColors['secondary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--color-issue-type-header',
      StrandColors['color-issue-type-header']
    );
    document.documentElement.style.setProperty(
      '--color-anchor-link',
      StrandColors['color-anchor-link']
    );
    document.documentElement.style.setProperty(
      '--color-left-nav-background',
      StrandColors['color-left-nav-background']
    );
    document.documentElement.style.setProperty(
      '--complete-button',
      StrandColors['complete-button']
    );
  } else if (theme === 'Formwerks') {
    document.documentElement.style.setProperty(
      '--color-expires-text',
      FormwerksColors['color-expires-text']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lightest',
      FormwerksColors['color-ink-lightest']
    );
    document.documentElement.style.setProperty(
      '--color-teal-dark',
      FormwerksColors['color-teal-dark']
    );
    document.documentElement.style.setProperty(
      '--button-background-color',
      FormwerksColors['button-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper',
      FormwerksColors['color-juniper']
    );
    document.documentElement.style.setProperty(
      '--toast-message-text',
      FormwerksColors['toast-message-text']
    );
    document.documentElement.style.setProperty(
      '--color-search-border',
      FormwerksColors['color-search-border']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lighter',
      FormwerksColors['color-ink-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-disabled-button',
      FormwerksColors['color-disabled-button']
    );
    document.documentElement.style.setProperty(
      '--color-sky',
      FormwerksColors['color-sky']
    );
    document.documentElement.style.setProperty(
      '--color-teal',
      FormwerksColors['color-teal']
    );
    document.documentElement.style.setProperty(
      '--color-sidebar-button-text',
      FormwerksColors['color-sidebar-button-text']
    );
    document.documentElement.style.setProperty(
      '--color-checkIcon',
      FormwerksColors['color-checkIcon']
    );
    document.documentElement.style.setProperty(
      '--walkthroughcompletecheckbox',
      FormwerksColors['walkthroughcompletecheckbox']
    );
    document.documentElement.style.setProperty(
      '--color-ink-light',
      FormwerksColors['color-ink-light']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-dark',
      FormwerksColors['color-juniper-dark']
    );
    document.documentElement.style.setProperty(
      '--tab-background-color',
      FormwerksColors['tab-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-darker',
      FormwerksColors['color-juniper-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-darker',
      FormwerksColors['color-red-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-lighter',
      FormwerksColors['color-red-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky-dark',
      FormwerksColors['color-sky-dark']
    );
    document.documentElement.style.setProperty(
      '--color-teal-darker',
      FormwerksColors['color-teal-darker']
    );
    document.documentElement.style.setProperty(
      '--color-teal-lighter',
      FormwerksColors['color-teal-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-lighter',
      FormwerksColors['color-yellow-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-darker',
      FormwerksColors['color-yellow-darker']
    );
    document.documentElement.style.setProperty(
      '--links',
      FormwerksColors['links']
    );
    document.documentElement.style.setProperty(
      '--color-dark',
      FormwerksColors['color-dark']
    );

    document.documentElement.style.setProperty(
      '--breadcrumb',
      FormwerksColors['breadcrumb']
    );
    document.documentElement.style.setProperty(
      '--left-nav-text-color',
      FormwerksColors['left-nav-text-color']
    );
    document.documentElement.style.setProperty(
      '--left-nav-active-text-color',
      FormwerksColors['left-nav-active-text-color']
    );
    document.documentElement.style.setProperty(
      '--time-line',
      FormwerksColors['time-line']
    );
    document.documentElement.style.setProperty(
      '--toast-background-shadow',
      FormwerksColors['toast-background-shadow']
    );
    document.documentElement.style.setProperty(
      '--icomoon-color',
      FormwerksColors['icomoon-color']
    );
    document.documentElement.style.setProperty(
      '--sidebar-tenant-color',
      FormwerksColors['sidebar-tenant-color']
    );
    document.documentElement.style.setProperty(
      '--closed-overview-color',
      FormwerksColors['closed-overview-color']
    );
    document.documentElement.style.setProperty(
      '--backGroundColors',
      FormwerksColors['backGroundColors']
    );
    document.documentElement.style.setProperty(
      '--recentActivityPanColor',
      FormwerksColors['recentActivityPanColor']
    );
    document.documentElement.style.setProperty(
      '--HOtitle',
      FormwerksColors['HOtitle']
    );
    document.documentElement.style.setProperty(
      '--textAreaOnFocusBroderHighLight',
      FormwerksColors['textAreaOnFocusBroderHighLight']
    );
    document.documentElement.style.setProperty(
      '--tableListHoverColor',
      FormwerksColors['tableListHoverColor']
    );

    document.documentElement.style.setProperty(
      '--toastSuccessColor',
      FormwerksColors['toastSuccessColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBackGroundColor',
      FormwerksColors['toastSuccessBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBorderColor',
      FormwerksColors['toastSuccessBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessProgressBarColor',
      FormwerksColors['toastSuccessProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessCloseButtonColor',
      FormwerksColors['toastSuccessCloseButtonColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorColor',
      FormwerksColors['toastErrorColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBackGroundColor',
      FormwerksColors['toastErrorBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBorderColor',
      FormwerksColors['toastErrorBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorProgressBarColor',
      FormwerksColors['toastErrorProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorCloseButtonColor',
      FormwerksColors['toastErrorCloseButtonColor']
    );

    document.documentElement.style.setProperty(
      '--primary-heading-font',
      FormwerksColors['primary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--general-content-font',
      FormwerksColors['general-content-font']
    );
    document.documentElement.style.setProperty(
      '--secondary-heading-font',
      FormwerksColors['secondary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--color-issue-type-header',
      FormwerksColors['color-issue-type-header']
    );
    document.documentElement.style.setProperty(
      '--color-anchor-link',
      FormwerksColors['color-anchor-link']
    );
    document.documentElement.style.setProperty(
      '--color-left-nav-background',
      FormwerksColors['color-left-nav-background']
    );
    document.documentElement.style.setProperty(
      '--complete-button',
      FormwerksColors['complete-button']
    );
    document.documentElement.style.setProperty(
      '--color-complete-button',
      FormwerksColors['color-complete-button']
    );
  } else if (theme === 'Shape') {
    const favIcon = document.getElementById('favicon');
    favIcon.href =
      'https://shapeproperties.com/wp-content/themes/shape/images/favicon-32x32.png';
    document.documentElement.style.setProperty(
      '--color-expires-text',
      ShapeColors['color-expires-text']
    );
    document.documentElement.style.setProperty(
      '--color-complete-button',
      ShapeColors['color-complete-button']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lightest',
      ShapeColors['color-ink-lightest']
    );
    document.documentElement.style.setProperty(
      '--color-teal-dark',
      ShapeColors['color-teal-dark']
    );
    document.documentElement.style.setProperty(
      '--button-background-color',
      ShapeColors['button-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper',
      ShapeColors['color-juniper']
    );
    document.documentElement.style.setProperty(
      '--toast-message-text',
      ShapeColors['toast-message-text']
    );
    document.documentElement.style.setProperty(
      '--color-search-border',
      ShapeColors['color-search-border']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lighter',
      ShapeColors['color-ink-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-disabled-button',
      ShapeColors['color-disabled-button']
    );
    document.documentElement.style.setProperty(
      '--color-sky',
      ShapeColors['color-sky']
    );
    document.documentElement.style.setProperty(
      '--color-teal',
      ShapeColors['color-teal']
    );
    document.documentElement.style.setProperty(
      '--color-checkIcon',
      ShapeColors['color-checkIcon']
    );
    document.documentElement.style.setProperty(
      '--walkthroughcompletecheckbox',
      ShapeColors['walkthroughcompletecheckbox']
    );
    document.documentElement.style.setProperty(
      '--color-ink-light',
      ShapeColors['color-ink-light']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-dark',
      ShapeColors['color-juniper-dark']
    );
    document.documentElement.style.setProperty(
      '--tab-background-color',
      ShapeColors['tab-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-darker',
      ShapeColors['color-juniper-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-darker',
      ShapeColors['color-red-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-lighter',
      ShapeColors['color-red-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky-dark',
      ShapeColors['color-sky-dark']
    );
    document.documentElement.style.setProperty(
      '--color-teal-darker',
      ShapeColors['color-teal-darker']
    );
    document.documentElement.style.setProperty(
      '--color-teal-lighter',
      ShapeColors['color-teal-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-lighter',
      ShapeColors['color-yellow-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-darker',
      ShapeColors['color-yellow-darker']
    );
    document.documentElement.style.setProperty('--links', ShapeColors['links']);
    document.documentElement.style.setProperty(
      '--color-dark',
      ShapeColors['color-dark']
    );

    document.documentElement.style.setProperty(
      '--breadcrumb',
      ShapeColors['breadcrumb']
    );
    document.documentElement.style.setProperty(
      '--left-nav-text-color',
      ShapeColors['left-nav-text-color']
    );
    document.documentElement.style.setProperty(
      '--left-nav-active-text-color',
      ShapeColors['left-nav-active-text-color']
    );
    document.documentElement.style.setProperty(
      '--time-line',
      ShapeColors['time-line']
    );
    document.documentElement.style.setProperty(
      '--toast-background-shadow',
      ShapeColors['toast-background-shadow']
    );
    document.documentElement.style.setProperty(
      '--icomoon-color',
      ShapeColors['icomoon-color']
    );
    document.documentElement.style.setProperty(
      '--sidebar-tenant-color',
      ShapeColors['sidebar-tenant-color']
    );
    document.documentElement.style.setProperty(
      '--closed-overview-color',
      ShapeColors['closed-overview-color']
    );
    document.documentElement.style.setProperty(
      '--backGroundColors',
      ShapeColors['backGroundColors']
    );
    document.documentElement.style.setProperty(
      '--recentActivityPanColor',
      ShapeColors['recentActivityPanColor']
    );
    document.documentElement.style.setProperty(
      '--HOtitle',
      ShapeColors['HOtitle']
    );
    document.documentElement.style.setProperty(
      '--textAreaOnFocusBroderHighLight',
      ShapeColors['textAreaOnFocusBroderHighLight']
    );
    document.documentElement.style.setProperty(
      '--tableListHoverColor',
      ShapeColors['tableListHoverColor']
    );

    document.documentElement.style.setProperty(
      '--toastSuccessColor',
      ShapeColors['toastSuccessColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBackGroundColor',
      ShapeColors['toastSuccessBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBorderColor',
      ShapeColors['toastSuccessBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessProgressBarColor',
      ShapeColors['toastSuccessProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessCloseButtonColor',
      ShapeColors['toastSuccessCloseButtonColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorColor',
      ShapeColors['toastErrorColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBackGroundColor',
      ShapeColors['toastErrorBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBorderColor',
      ShapeColors['toastErrorBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorProgressBarColor',
      ShapeColors['toastErrorProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorCloseButtonColor',
      ShapeColors['toastErrorCloseButtonColor']
    );

    document.documentElement.style.setProperty(
      '--primary-heading-font',
      ShapeColors['primary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--general-content-font',
      ShapeColors['general-content-font']
    );
    document.documentElement.style.setProperty(
      '--secondary-heading-font',
      ShapeColors['secondary-heading-font']
    );

    document.documentElement.style.setProperty(
      '--color-issue-type-header',
      ShapeColors['color-issue-type-header']
    );
    document.documentElement.style.setProperty(
      '--color-anchor-link',
      ShapeColors['color-anchor-link']
    );

    document.documentElement.style.setProperty(
      '--color-left-nav-background',
      ShapeColors['color-left-nav-background']
    );
    document.documentElement.style.setProperty(
      '--complete-button',
      ShapeColors['complete-button']
    );
  } else if (theme === 'Quadra') {
    document.documentElement.style.setProperty(
      '--color-expires-text',
      QuadraColors['color-expires-text']
    );
    document.documentElement.style.setProperty(
      '--color-complete-button',
      QuadraColors['color-complete-button']
    );
    document.documentElement.style.setProperty(
      '--primary-heading-font',
      QuadraColors['primary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--general-content-font',
      QuadraColors['general-content-font']
    );
    document.documentElement.style.setProperty(
      '--secondary-heading-font',
      QuadraColors['secondary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lightest',
      QuadraColors['color-ink-lightest']
    );
    document.documentElement.style.setProperty(
      '--color-teal-dark',
      QuadraColors['color-teal-dark']
    );
    document.documentElement.style.setProperty(
      '--button-background-color',
      QuadraColors['button-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper',
      QuadraColors['color-juniper']
    );
    document.documentElement.style.setProperty(
      '--toast-message-text',
      QuadraColors['toast-message-text']
    );
    document.documentElement.style.setProperty(
      '--color-search-border',
      QuadraColors['color-search-border']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lighter',
      QuadraColors['color-ink-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-disabled-button',
      QuadraColors['color-disabled-button']
    );
    document.documentElement.style.setProperty(
      '--color-sky',
      QuadraColors['color-sky']
    );
    document.documentElement.style.setProperty(
      '--color-teal',
      QuadraColors['color-teal']
    );
    document.documentElement.style.setProperty(
      '--color-checkIcon',
      QuadraColors['color-checkIcon']
    );
    document.documentElement.style.setProperty(
      '--walkthroughcompletecheckbox',
      QuadraColors['walkthroughcompletecheckbox']
    );
    document.documentElement.style.setProperty(
      '--color-ink-light',
      QuadraColors['color-ink-light']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-dark',
      QuadraColors['color-juniper-dark']
    );
    document.documentElement.style.setProperty(
      '--tab-background-color',
      QuadraColors['tab-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-darker',
      QuadraColors['color-juniper-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-darker',
      QuadraColors['color-red-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-lighter',
      QuadraColors['color-red-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky-dark',
      QuadraColors['color-sky-dark']
    );
    document.documentElement.style.setProperty(
      '--color-teal-darker',
      QuadraColors['color-teal-darker']
    );
    document.documentElement.style.setProperty(
      '--color-teal-lighter',
      QuadraColors['color-teal-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-lighter',
      QuadraColors['color-yellow-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-darker',
      QuadraColors['color-yellow-darker']
    );
    document.documentElement.style.setProperty(
      '--links',
      QuadraColors['links']
    );
    document.documentElement.style.setProperty(
      '--color-dark',
      QuadraColors['color-dark']
    );

    document.documentElement.style.setProperty(
      '--breadcrumb',
      QuadraColors['breadcrumb']
    );
    document.documentElement.style.setProperty(
      '--left-nav-text-color',
      QuadraColors['left-nav-text-color']
    );
    document.documentElement.style.setProperty(
      '--left-nav-active-text-color',
      QuadraColors['left-nav-active-text-color']
    );
    document.documentElement.style.setProperty(
      '--time-line',
      QuadraColors['time-line']
    );
    document.documentElement.style.setProperty(
      '--toast-background-shadow',
      QuadraColors['toast-background-shadow']
    );
    document.documentElement.style.setProperty(
      '--icomoon-color',
      QuadraColors['icomoon-color']
    );
    document.documentElement.style.setProperty(
      '--sidebar-tenant-color',
      QuadraColors['sidebar-tenant-color']
    );
    document.documentElement.style.setProperty(
      '--closed-overview-color',
      QuadraColors['closed-overview-color']
    );
    document.documentElement.style.setProperty(
      '--backGroundColors',
      QuadraColors['backGroundColors']
    );
    document.documentElement.style.setProperty(
      '--recentActivityPanColor',
      QuadraColors['recentActivityPanColor']
    );
    document.documentElement.style.setProperty(
      '--HOtitle',
      QuadraColors['HOtitle']
    );
    document.documentElement.style.setProperty(
      '--textAreaOnFocusBroderHighLight',
      QuadraColors['textAreaOnFocusBroderHighLight']
    );
    document.documentElement.style.setProperty(
      '--tableListHoverColor',
      QuadraColors['tableListHoverColor']
    );

    document.documentElement.style.setProperty(
      '--toastSuccessColor',
      QuadraColors['toastSuccessColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBackGroundColor',
      QuadraColors['toastSuccessBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBorderColor',
      QuadraColors['toastSuccessBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessProgressBarColor',
      QuadraColors['toastSuccessProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessCloseButtonColor',
      QuadraColors['toastSuccessCloseButtonColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorColor',
      QuadraColors['toastErrorColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBackGroundColor',
      QuadraColors['toastErrorBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBorderColor',
      QuadraColors['toastErrorBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorProgressBarColor',
      QuadraColors['toastErrorProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorCloseButtonColor',
      QuadraColors['toastErrorCloseButtonColor']
    );

    document.documentElement.style.setProperty(
      '--color-issue-type-header',
      QuadraColors['color-issue-type-header']
    );
    document.documentElement.style.setProperty(
      '--color-anchor-link',
      QuadraColors['color-anchor-link']
    );
    document.documentElement.style.setProperty(
      '--color-left-nav-background',
      QuadraColors['color-left-nav-background']
    );
    document.documentElement.style.setProperty(
      '--complete-button',
      QuadraColors['complete-button']
    );
  } else if (theme === 'Panatch') {
    document.documentElement.style.setProperty(
      '--color-expires-text',
      PanatchColors['color-expires-text']
    );
    document.documentElement.style.setProperty(
      '--color-complete-button',
      PanatchColors['color-complete-button']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lightest',
      PanatchColors['color-ink-lightest']
    );
    document.documentElement.style.setProperty(
      '--color-teal-dark',
      PanatchColors['color-teal-dark']
    );
    document.documentElement.style.setProperty(
      '--button-background-color',
      PanatchColors['button-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper',
      PanatchColors['color-juniper']
    );
    document.documentElement.style.setProperty(
      '--toast-message-text',
      PanatchColors['toast-message-text']
    );
    document.documentElement.style.setProperty(
      '--color-search-border',
      PanatchColors['color-search-border']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lighter',
      PanatchColors['color-ink-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-disabled-button',
      PanatchColors['color-disabled-button']
    );
    document.documentElement.style.setProperty(
      '--color-sky',
      PanatchColors['color-sky']
    );
    document.documentElement.style.setProperty(
      '--color-teal',
      PanatchColors['color-teal']
    );
    document.documentElement.style.setProperty(
      '--color-checkIcon',
      PanatchColors['color-checkIcon']
    );
    document.documentElement.style.setProperty(
      '--walkthroughcompletecheckbox',
      PanatchColors['walkthroughcompletecheckbox']
    );
    document.documentElement.style.setProperty(
      '--color-ink-light',
      PanatchColors['color-ink-light']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-dark',
      PanatchColors['color-juniper-dark']
    );
    document.documentElement.style.setProperty(
      '--tab-background-color',
      PanatchColors['tab-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-darker',
      PanatchColors['color-juniper-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-darker',
      PanatchColors['color-red-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-lighter',
      PanatchColors['color-red-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky-dark',
      PanatchColors['color-sky-dark']
    );
    document.documentElement.style.setProperty(
      '--color-teal-darker',
      PanatchColors['color-teal-darker']
    );
    document.documentElement.style.setProperty(
      '--color-teal-lighter',
      PanatchColors['color-teal-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-lighter',
      PanatchColors['color-yellow-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-darker',
      PanatchColors['color-yellow-darker']
    );
    document.documentElement.style.setProperty(
      '--links',
      PanatchColors['links']
    );
    document.documentElement.style.setProperty(
      '--color-dark',
      PanatchColors['color-dark']
    );

    document.documentElement.style.setProperty(
      '--breadcrumb',
      PanatchColors['breadcrumb']
    );
    document.documentElement.style.setProperty(
      '--left-nav-text-color',
      PanatchColors['left-nav-text-color']
    );
    document.documentElement.style.setProperty(
      '--left-nav-active-text-color',
      PanatchColors['left-nav-active-text-color']
    );
    document.documentElement.style.setProperty(
      '--time-line',
      PanatchColors['time-line']
    );
    document.documentElement.style.setProperty(
      '--toast-background-shadow',
      PanatchColors['toast-background-shadow']
    );
    document.documentElement.style.setProperty(
      '--icomoon-color',
      PanatchColors['icomoon-color']
    );
    document.documentElement.style.setProperty(
      '--sidebar-tenant-color',
      PanatchColors['sidebar-tenant-color']
    );
    document.documentElement.style.setProperty(
      '--closed-overview-color',
      PanatchColors['closed-overview-color']
    );
    document.documentElement.style.setProperty(
      '--backGroundColors',
      PanatchColors['backGroundColors']
    );
    document.documentElement.style.setProperty(
      '--recentActivityPanColor',
      PanatchColors['recentActivityPanColor']
    );
    document.documentElement.style.setProperty(
      '--HOtitle',
      PanatchColors['HOtitle']
    );
    document.documentElement.style.setProperty(
      '--textAreaOnFocusBroderHighLight',
      PanatchColors['textAreaOnFocusBroderHighLight']
    );
    document.documentElement.style.setProperty(
      '--tableListHoverColor',
      PanatchColors['tableListHoverColor']
    );

    document.documentElement.style.setProperty(
      '--toastSuccessColor',
      PanatchColors['toastSuccessColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBackGroundColor',
      PanatchColors['toastSuccessBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBorderColor',
      PanatchColors['toastSuccessBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessProgressBarColor',
      PanatchColors['toastSuccessProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessCloseButtonColor',
      PanatchColors['toastSuccessCloseButtonColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorColor',
      PanatchColors['toastErrorColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBackGroundColor',
      PanatchColors['toastErrorBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBorderColor',
      PanatchColors['toastErrorBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorProgressBarColor',
      PanatchColors['toastErrorProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorCloseButtonColor',
      PanatchColors['toastErrorCloseButtonColor']
    );

    document.documentElement.style.setProperty(
      '--primary-heading-font',
      PanatchColors['primary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--general-content-font',
      PanatchColors['general-content-font']
    );
    document.documentElement.style.setProperty(
      '--secondary-heading-font',
      PanatchColors['secondary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--color-issue-type-header',
      PanatchColors['color-issue-type-header']
    );
    document.documentElement.style.setProperty(
      '--color-anchor-link',
      PanatchColors['color-anchor-link']
    );
    document.documentElement.style.setProperty(
      '--color-left-nav-background',
      PanatchColors['color-left-nav-background']
    );
    document.documentElement.style.setProperty(
      '--complete-button',
      PanatchColors['complete-button']
    );
  } else if (theme === 'GateHouse') {
    document.documentElement.style.setProperty(
      '--color-expires-text',
      GateHouseColors['color-expires-text']
    );
    document.documentElement.style.setProperty(
      '--color-complete-button',
      GateHouseColors['color-complete-button']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lightest',
      GateHouseColors['color-ink-lightest']
    );
    document.documentElement.style.setProperty(
      '--color-teal-dark',
      GateHouseColors['color-teal-dark']
    );
    document.documentElement.style.setProperty(
      '--button-background-color',
      GateHouseColors['button-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper',
      GateHouseColors['color-juniper']
    );
    document.documentElement.style.setProperty(
      '--toast-message-text',
      GateHouseColors['toast-message-text']
    );
    document.documentElement.style.setProperty(
      '--color-search-border',
      GateHouseColors['color-search-border']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lighter',
      GateHouseColors['color-ink-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-disabled-button',
      GateHouseColors['color-disabled-button']
    );
    document.documentElement.style.setProperty(
      '--color-sky',
      GateHouseColors['color-sky']
    );
    document.documentElement.style.setProperty(
      '--color-teal',
      GateHouseColors['color-teal']
    );
    document.documentElement.style.setProperty(
      '--color-sidebar-button-text',
      GateHouseColors['color-sidebar-button-text']
    );
    document.documentElement.style.setProperty(
      '--color-checkIcon',
      GateHouseColors['color-checkIcon']
    );
    document.documentElement.style.setProperty(
      '--walkthroughcompletecheckbox',
      GateHouseColors['walkthroughcompletecheckbox']
    );
    document.documentElement.style.setProperty(
      '--color-ink-light',
      GateHouseColors['color-ink-light']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-dark',
      GateHouseColors['color-juniper-dark']
    );
    document.documentElement.style.setProperty(
      '--tab-background-color',
      GateHouseColors['tab-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-darker',
      GateHouseColors['color-juniper-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-darker',
      GateHouseColors['color-red-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-lighter',
      GateHouseColors['color-red-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky-dark',
      GateHouseColors['color-sky-dark']
    );
    document.documentElement.style.setProperty(
      '--color-teal-darker',
      GateHouseColors['color-teal-darker']
    );
    document.documentElement.style.setProperty(
      '--color-teal-lighter',
      GateHouseColors['color-teal-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-lighter',
      GateHouseColors['color-yellow-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-darker',
      GateHouseColors['color-yellow-darker']
    );
    document.documentElement.style.setProperty(
      '--links',
      GateHouseColors['links']
    );
    document.documentElement.style.setProperty(
      '--color-dark',
      GateHouseColors['color-dark']
    );

    document.documentElement.style.setProperty(
      '--breadcrumb',
      GateHouseColors['breadcrumb']
    );
    document.documentElement.style.setProperty(
      '--left-nav-text-color',
      GateHouseColors['left-nav-text-color']
    );
    document.documentElement.style.setProperty(
      '--left-nav-active-text-color',
      GateHouseColors['left-nav-active-text-color']
    );
    document.documentElement.style.setProperty(
      '--time-line',
      GateHouseColors['time-line']
    );
    document.documentElement.style.setProperty(
      '--toast-background-shadow',
      GateHouseColors['toast-background-shadow']
    );
    document.documentElement.style.setProperty(
      '--icomoon-color',
      GateHouseColors['icomoon-color']
    );
    document.documentElement.style.setProperty(
      '--sidebar-tenant-color',
      GateHouseColors['sidebar-tenant-color']
    );
    document.documentElement.style.setProperty(
      '--closed-overview-color',
      GateHouseColors['closed-overview-color']
    );
    document.documentElement.style.setProperty(
      '--backGroundColors',
      GateHouseColors['backGroundColors']
    );
    document.documentElement.style.setProperty(
      '--recentActivityPanColor',
      GateHouseColors['recentActivityPanColor']
    );
    document.documentElement.style.setProperty(
      '--HOtitle',
      GateHouseColors['HOtitle']
    );
    document.documentElement.style.setProperty(
      '--textAreaOnFocusBroderHighLight',
      GateHouseColors['textAreaOnFocusBroderHighLight']
    );
    document.documentElement.style.setProperty(
      '--tableListHoverColor',
      GateHouseColors['tableListHoverColor']
    );

    document.documentElement.style.setProperty(
      '--toastSuccessColor',
      GateHouseColors['toastSuccessColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBackGroundColor',
      GateHouseColors['toastSuccessBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBorderColor',
      GateHouseColors['toastSuccessBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessProgressBarColor',
      GateHouseColors['toastSuccessProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessCloseButtonColor',
      GateHouseColors['toastSuccessCloseButtonColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorColor',
      GateHouseColors['toastErrorColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBackGroundColor',
      GateHouseColors['toastErrorBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBorderColor',
      GateHouseColors['toastErrorBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorProgressBarColor',
      GateHouseColors['toastErrorProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorCloseButtonColor',
      GateHouseColors['toastErrorCloseButtonColor']
    );

    document.documentElement.style.setProperty(
      '--primary-heading-font',
      GateHouseColors['primary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--general-content-font',
      GateHouseColors['general-content-font']
    );
    document.documentElement.style.setProperty(
      '--secondary-heading-font',
      GateHouseColors['secondary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--color-issue-type-header',
      GateHouseColors['color-issue-type-header']
    );
    document.documentElement.style.setProperty(
      '--color-anchor-link',
      GateHouseColors['color-anchor-link']
    );
    document.documentElement.style.setProperty(
      '--color-left-nav-background',
      GateHouseColors['color-left-nav-background']
    );
    document.documentElement.style.setProperty(
      '--complete-button',
      GateHouseColors['complete-button']
    );
  } else {
    document.documentElement.style.setProperty(
      '--color-expires-text',
      JuniperColors['color-expires-text']
    );
    document.documentElement.style.setProperty(
      '--color-complete-button',
      JuniperColors['color-complete-button']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lightest',
      JuniperColors['color-ink-lightest']
    );
    document.documentElement.style.setProperty(
      '--color-teal-dark',
      JuniperColors['color-teal-dark']
    );
    document.documentElement.style.setProperty(
      '--button-background-color',
      JuniperColors['button-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper',
      JuniperColors['color-juniper']
    );
    document.documentElement.style.setProperty(
      '--toast-message-text',
      JuniperColors['toast-message-text']
    );
    document.documentElement.style.setProperty(
      '--color-search-border',
      JuniperColors['color-search-border']
    );
    document.documentElement.style.setProperty(
      '--color-ink-lighter',
      JuniperColors['color-ink-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-disabled-button',
      JuniperColors['color-disabled-button']
    );
    document.documentElement.style.setProperty(
      '--color-sky',
      JuniperColors['color-sky']
    );
    document.documentElement.style.setProperty(
      '--color-teal',
      JuniperColors['color-teal']
    );
    document.documentElement.style.setProperty(
      '--color-sidebar-button-text',
      JuniperColors['color-sidebar-button-text']
    );
    document.documentElement.style.setProperty(
      '--color-checkIcon',
      JuniperColors['color-checkIcon']
    );
    document.documentElement.style.setProperty(
      '--walkthroughcompletecheckbox',
      JuniperColors['walkthroughcompletecheckbox']
    );
    document.documentElement.style.setProperty(
      '--color-ink-light',
      JuniperColors['color-ink-light']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-dark',
      JuniperColors['color-juniper-dark']
    );
    document.documentElement.style.setProperty(
      '--tab-background-color',
      JuniperColors['tab-background-color']
    );
    document.documentElement.style.setProperty(
      '--color-juniper-darker',
      JuniperColors['color-juniper-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-darker',
      JuniperColors['color-red-darker']
    );
    document.documentElement.style.setProperty(
      '--color-red-lighter',
      JuniperColors['color-red-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-sky-dark',
      JuniperColors['color-sky-dark']
    );
    document.documentElement.style.setProperty(
      '--color-teal-darker',
      JuniperColors['color-teal-darker']
    );
    document.documentElement.style.setProperty(
      '--color-teal-lighter',
      JuniperColors['color-teal-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-lighter',
      JuniperColors['color-yellow-lighter']
    );
    document.documentElement.style.setProperty(
      '--color-yellow-darker',
      JuniperColors['color-yellow-darker']
    );
    document.documentElement.style.setProperty(
      '--links',
      JuniperColors['links']
    );
    document.documentElement.style.setProperty(
      '--color-dark',
      JuniperColors['color-dark']
    );

    document.documentElement.style.setProperty(
      '--breadcrumb',
      JuniperColors['breadcrumb']
    );
    document.documentElement.style.setProperty(
      '--left-nav-text-color',
      JuniperColors['left-nav-text-color']
    );
    document.documentElement.style.setProperty(
      '--left-nav-active-text-color',
      JuniperColors['left-nav-active-text-color']
    );
    document.documentElement.style.setProperty(
      '--time-line',
      JuniperColors['time-line']
    );
    document.documentElement.style.setProperty(
      '--toast-background-shadow',
      JuniperColors['toast-background-shadow']
    );
    document.documentElement.style.setProperty(
      '--icomoon-color',
      JuniperColors['icomoon-color']
    );
    document.documentElement.style.setProperty(
      '--sidebar-tenant-color',
      JuniperColors['sidebar-tenant-color']
    );
    document.documentElement.style.setProperty(
      '--closed-overview-color',
      JuniperColors['closed-overview-color']
    );
    document.documentElement.style.setProperty(
      '--backGroundColors',
      JuniperColors['backGroundColors']
    );
    document.documentElement.style.setProperty(
      '--recentActivityPanColor',
      JuniperColors['recentActivityPanColor']
    );
    document.documentElement.style.setProperty(
      '--HOtitle',
      JuniperColors['HOtitle']
    );
    document.documentElement.style.setProperty(
      '--textAreaOnFocusBroderHighLight',
      JuniperColors['textAreaOnFocusBroderHighLight']
    );
    document.documentElement.style.setProperty(
      '--tableListHoverColor',
      JuniperColors['tableListHoverColor']
    );

    document.documentElement.style.setProperty(
      '--toastSuccessColor',
      JuniperColors['toastSuccessColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBackGroundColor',
      JuniperColors['toastSuccessBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessBorderColor',
      JuniperColors['toastSuccessBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessProgressBarColor',
      JuniperColors['toastSuccessProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastSuccessCloseButtonColor',
      JuniperColors['toastSuccessCloseButtonColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorColor',
      JuniperColors['toastErrorColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBackGroundColor',
      JuniperColors['toastErrorBackGroundColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorBorderColor',
      JuniperColors['toastErrorBorderColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorProgressBarColor',
      JuniperColors['toastErrorProgressBarColor']
    );
    document.documentElement.style.setProperty(
      '--toastErrorCloseButtonColor',
      JuniperColors['toastErrorCloseButtonColor']
    );

    document.documentElement.style.setProperty(
      '--primary-heading-font',
      JuniperColors['primary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--general-content-font',
      JuniperColors['general-content-font']
    );
    document.documentElement.style.setProperty(
      '--secondary-heading-font',
      JuniperColors['secondary-heading-font']
    );
    document.documentElement.style.setProperty(
      '--color-issue-type-header',
      JuniperColors['color-issue-type-header']
    );
    document.documentElement.style.setProperty(
      '--color-anchor-link',
      JuniperColors['color-anchor-link']
    );
    document.documentElement.style.setProperty(
      '--color-left-nav-background',
      JuniperColors['color-left-nav-background']
    );
    document.documentElement.style.setProperty(
      '--complete-button',
      JuniperColors['complete-button']
    );
  }
};

export const setTenantImages = (theme) => {
  let tenantObj = tenants.filter((tn) => tn.tenant === theme)[0];
  Images = tenantObj && tenantObj.extraInfo ? tenantObj.extraInfo : {};
};

export const setTenantColors = (theme) => {
  if (theme === 'Albaster') {
    Colors = {
      toggleActive: '#A19A94',
      svgColor: '#A19A94',
      toggleAndButtonColor: '#A19A94',
    };
  } else if (theme === 'Rize') {
    Colors = {
      toggleActive: '#DE5722',
      svgColor: '#DE5722',
      toggleAndButtonColor: '#DE5722',
    };
  } else if (theme === 'Strand') {
    Colors = {
      toggleActive: '#1D1D1D',
      svgColor: '#414141',
      toggleAndButtonColor: '#000000',
    };
  } else if (theme === 'Formwerks') {
    Colors = {
      toggleActive: '#1D1D1D',
      svgColor: '#002D56',
      // buttonColor: "#002D56",
      buttonTextColor: '#002D56',
      toggleAndButtonColor: '#002D56',
    };
  } else if (theme === 'Shape') {
    Colors = {
      toggleActive: '#1D1D1D',
      svgColor: '#002D56',
      toggleAndButtonColor: '#000000',
    };
  } else if (theme === 'Panatch') {
    Colors = {
      toggleActive: '#909191',
      svgColor: '#002D56',
      buttonTextColor: '#1D295D',
      toggleAndButtonColor: '#1D295D',
    };
  } else if (theme === 'GateHouse') {
    Colors = {
      toggleActive: '#386BB3',
      svgColor: '#002D56',
      buttonTextColor: '#887D79',
      toggleAndButtonColor: '#386BB3',
    };
  } else {
    Colors = {
      toggleActive: '#47C1BF', //sec
      svgColor: '#00848E', //sec.dark
      toggleAndButtonColor: theme === 'Quadra' ? '#000000' : '#00848E',
    };
  }
};

export const setTenantVariables = (theme) => {
  if (theme === 'Deficiency Group') {
    variables = {
      suiteName: 'Locations',
      Suite: 'Location',
      suite: 'location',
      suites: 'locations',

      serviceRequest: 'Service Request',

      roomName: 'Area',

      homeOwners: 'Clients',
      homeOwnerss: 'Clients',
      homeOwner: 'Client',

      propertyDeveloper: 'Service Manager',
      propertyDevelopers: 'service managers',

      developers: 'Managers',
      developerss: 'managers',
      developer: 'Manager',
      roomsAndItems: 'Areas and Items',
      termsOfUse: 'Terms of Use',
      conveyance: 'Conveyance',
      userActivationMessage:
        'Welcome to Juniper, you have successfully activated your account! Please create your password below.',
    };
  } else if (theme === 'Shape') {
    variables = {
      suiteName: 'Units',
      Suite: 'Unit',
      suite: 'unit',
      suites: 'units',
      serviceRequest: 'Service Request',

      roomName: 'Room',

      homeOwners: 'Home Owners',
      homeOwnerss: 'Homeowners',
      homeOwner: 'Homeowner',

      propertyDeveloper: 'Property Developer',
      propertyDevelopers: 'property developers',

      developers: 'Developers',
      developerss: 'developers',
      developer: 'Developer',
      roomsAndItems: 'Rooms and Items',
      termsOfUse: 'I accept the Terms of Use',
      conveyance: 'Conveyance',
      userActivationMessage:
        'Welcome to your SHAPE Customer Care Homeowner Dashboard, you have successfully activated your account! Please create your password below.',
    };
  } else {
    variables = {
      suiteName: 'Suites',
      Suite: 'Suite',
      suite: 'suite',
      suites: 'suites',
      serviceRequest: 'Service Request',

      roomName: 'Room',

      homeOwners: 'Home Owners',
      homeOwnerss: 'Homeowners',
      homeOwner: 'Homeowner',

      propertyDeveloper: 'Property Developer',
      propertyDevelopers: 'property developers',

      developers: 'Developers',
      developerss: 'developers',
      developer: 'Developer',
      roomsAndItems: 'Rooms and Items',
      termsOfUse: 'Terms of Use',
      conveyance: 'Conveyance',
      userActivationMessage:
        'Welcome to Juniper, you have successfully activated your account! Please create your password below.',
    };
  }
};

export const setTenantAPIURL = (theme) => {
  let tenantObj = tenants.find((tn) => tn.tenant === theme);

  if (!tenantObj) {
    console.warn(
      `No tenant found for theme: ${theme}. Using fallback API URL.`
    );
  }

  // Use environment variables for API fallbacks based on environment
  baseUrl =
    tenantObj?.apiUrl ||
    (import.meta.env.PROD
      ? import.meta.env.VITE_API_URL_FALLBACK_PROD // Production fallback.
      : import.meta.env.VITE_API_URL_FALLBACK_DEV); // Development fallback.
};

export const setTenantResolutionHeader = (theme) => {
  let tenantObj = tenants.filter((tn) => tn.tenant === theme)[0];
  resolutionHeader =
    tenantObj && tenantObj.resolutionHeaderValue
      ? tenantObj.resolutionHeaderValue
      : '';
};

export const setTenantAnalytics = (theme) => {
  let tenantObj = tenants.filter((tn) => tn.tenant === theme)[0];
  AnalyticsKey =
    tenantObj && tenantObj.analyticsKey ? tenantObj.analyticsKey : '';
};

// setting hotjar key based on the tenant url
export const setHotJarKey = (theme) => {
  let tenantObj = tenants.filter((tn) => tn.tenant === theme)[0];
  const hotjarKey = tenantObj && tenantObj.hotjarKey ? tenantObj.hotjarKey : '';
  if (hotjarKey) {
    const siteId = hotjarKey;
    const hotjarVersion = HOTJAR_VERSION;
    Hotjar.init(siteId, hotjarVersion);
  }
};
var keyhandoffSignatureTermsAndConditions =
  "I acknowledge that I've received the necessary number of keys as stated in my homeowner care account for my home and communal spaces. I acknowledge that I have received all information for access to my home and homeowner care account and confirm the information shared with me is understood and accurate.";
export {
  Images,
  Colors,
  variables,
  baseUrl,
  AnalyticsKey,
  keyhandoffSignatureTermsAndConditions,
  resolutionHeader,
};

export const emptyCache = () => {
  let version = localStorage.getItem('version');
  if (version != packageJson.version) {
    if ('caches' in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });

      // Makes sure the page reloads. Changes are only visible after you refresh.
      window.location.reload(true);
    }
    localStorage.clear();
    localStorage.setItem('version', packageJson.version);
    verifyTenent(window.location.origin);
  } else {
    verifyTenent(window.location.origin);
  }
};

// function to fetch the deployment version from API.
export const getDeploymentVersion = async (url) => {
  let tenantObj = tenants.filter((tn) => matchUrl(tn.urls, url))[0];
  let baseAPIUrl = tenantObj && tenantObj.apiUrl ? tenantObj.apiUrl : '';
  let tenantId =
    tenantObj && tenantObj.resolutionHeaderValue
      ? tenantObj.resolutionHeaderValue
      : '';
  const apiUrl = baseAPIUrl + 'api/Common/BuildVersion';
  const buildVersion = packageJson.buildVersion;
  console.log(buildVersion + '==buildVersion');

  let data = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Tenant-Id': tenantId,
    },
  };

  await fetch(apiUrl, data)
    .then((response) => {
      if (response && response.status === 200) {
        response.json().then((responseJson) => {
          console.log(responseJson + '==APIbuildVersion');
          if (responseJson !== buildVersion) {
            store.dispatch(setBuildVersion(responseJson));
          } else {
            store.dispatch(setBuildVersion(''));
          }
        });
      } else {
        store.dispatch(setBuildVersion(''));
      }
    })
    .catch((error) => {
      store.dispatch(setBuildVersion(''));
    });
};

// function to clear the application cache.
export const clearCacheData = async () => {
  caches.keys().then((keyList) => {
    return Promise.all(
      keyList.map((key) => {
        return caches.delete(key);
      })
    );
  });
  store.dispatch(setBuildVersion(''));
  // setTimeout(() => {
  window.location.reload(true);
  // }, 1000);
};

// function to check the session time out and generate a new token.
export const onCheckAutherizationToken = async () => {
  const interval = setInterval(async () => {
    const token = JSON.parse(localStorage.getItem('auth'));
    if (token) {
      var tokenDecoded = jwtDecode(token);
      if (tokenDecoded && tokenDecoded.exp) {
        let checkActivityTime = tokenDecoded.exp - 1200;
        // console.log(checkActivityTime - Date.now() / 1000 + '===CALCULATETIME');
        if (
          checkActivityTime <= Date.now() / 1000 &&
          tokenDecoded.exp >= Date.now() / 1000
        ) {
          let user = JSON.parse(localStorage.getItem('user'));
          if (user && user.id) {
            getNewAuthorizationToken(user.id);
          }
        } else if (tokenDecoded.exp < Date.now() / 1000) {
          toast.error(' 🚫 Your session has timed out, please login again.', {
            autoClose: 12000,
            position: 'top-center',
          });
          let user = JSON.parse(localStorage.getItem('user'));
          if (user && user.id) {
            let report = {
              UserId: user.id,
              Event: 'Logout',
            };
            await setReport(report);
          }
          const timer = setTimeout(() => {
            localStorage.setItem('sessionTimeOut', 'true');
            localStorage.removeItem('redirectURL');
            localStorage.removeItem('userId');
            localStorage.removeItem('auth');
            localStorage.removeItem('user');
            localStorage.removeItem('persist:root');
            localStorage.removeItem('IsHomerNavigatFromFeedBackTemplate');
            if (localStorage.getItem('isAnnotationImageUpload') === 'true') {
              localStorage.removeItem('isAnnotationImageUpload');
              toast.error(
                ' 🚫There seems to be some problem with the low memory, unable to process the request now.',
                {
                  autoClose: 12000,
                  position: 'top-center',
                }
              );
            } else {
              window.location.href =
                window.location.origin + PATHS.AUTH_SIGN_IN;
            }
          }, 2000);
          return () => clearTimeout(timer);
        }
      }
    }
    // console.log('This will be called every 1 minute');
  }, 60 * 1000);
  return () => clearInterval(interval);
};
